import Challenges from './ui/main/Challenges';
import { challengesSegment } from './model/state-manager/challengesSegment';
import { ACHIEVEMENTS, CHALLENGES } from './constants/tabs';

export default Challenges;
export { challengesSegment, CHALLENGES, ACHIEVEMENTS };
